package api.utils

enum class EnumCurrencies(val country: String, val code: String){
    TZS("Tanzania", "TZS"),
    USD("United States of America", "USD")
}